import {
  LandingHeader,
  HeroSection,
  FeaturesSection,
  PricingSection,
  CTASection,
  LandingFooter,
} from '@/components/landing';

const LandingPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <LandingHeader />
      <main className="flex-1">
        <HeroSection />
        <FeaturesSection />
        <PricingSection />
        <CTASection />
      </main>
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
